import React from 'react'
import Hoc from '../../../components/HOC';
import Loader from '../../../components/Loader';
import CustomDataTable from '../../../components/CustomDataTable';
import ModalComponent from '../../../components/Modal';
import TextAreaInput from '../../../components/TextArea';
import TimeOffForm from './TimeOffForm';
import { useState ,useEffect} from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { requestApproveTimeOffRequestAction, requestTimeOffRequestsAction, setResetTimeOffRequestsState, resetApproveTimeOffRequestState, resetCreateTimeOffRequestState, resetUpdateTimeOffRequestState, resetGetTimeOffByIdState } from '../../../Redux/TimeOffManagerState/TimeOffManagerActionCreator';
import { requestUsersListActionWithOutPagination } from '../../../Redux/UserState/UserActionCreator';
import { FcApproval } from 'react-icons/fc';
import { MdCancel } from 'react-icons/md';
import { MdEdit , MdVisibility} from 'react-icons/md';
import { toast } from 'react-toastify';
import CustomToolTip from '../../../components/ToolTip';
import moment from 'moment';
import { AddRounded } from '@mui/icons-material';





const TimeOff = () => {

  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(''); // 'approve', 'reject', or 'edit'
  const [selectedId, setSelectedId] = useState(null);
  const [note, setNote] = useState('');
  const [showTimeOffForm, setShowTimeOffForm] = useState(false);
  const [selectedTimeOff, setSelectedTimeOff] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const dispatch = useDispatch();
  const timeOffRequestsState = useSelector((state) => state.TimeOffRequestsReducer);
  const approveTimeOffRequestState = useSelector((state) => state.ApproveTimeOffRequestReducer);
  const updateTimeOffRequestState = useSelector((state) => state.UpdateTimeOffRequestReducer);
  const usersList = useSelector((state) => state.UsersListWithOutPagination);
  const createTimeOffRequestState = useSelector((state) => state.CreateTimeOffRequestReducer);
   
  const columns = [
    {
      name: 'Employee Name',
      selector: (row) => row.userName,
      maxWidth: '10vw',
    },
    {
      name: 'Start Date',
      selector: (row) => row.startDate ? moment(row.startDate).format('MM-DD-YYYY') : '-',
      maxWidth: '8vw',
    },
    {
      name: 'End Date',
      selector: (row) => row.endDate ? moment(row.endDate).format('MM-DD-YYYY') : '-',
      maxWidth: '8vw',
    },
    {
      name: "Type",
      selector: (row) => row.type,
      // sortable: true,
      cell: (row) => (
        <div className="text-sm text-gray-900 capitalize">
          {row.type?.replace("_", " ")}
        </div>
      ),
      maxWidth: '8vw',
    },
    {
      name: 'Total Days',
      selector: (row) => row.totalDays,
      cell: (row) => (
        <div className="text-sm text-gray-900 text-center">
          {row.totalDays}
        </div>
      ),
      maxWidth: '7vw',
      
      
      
    },
    {
      name: 'Reason',
      selector: (row) => row.reason,
      wrap: true,
      cell: (row) => (
        <div
          className="text-sm text-gray-900 max-w-xs truncate"
          title={row.reason || ""}
        >
          {row.reason}
        </div>
      ),
      maxWidth: '9vw',
      tooltip: true,
    },
    {
      name: 'Status',
      selector: (row) => (
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
          row.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
          row.status === 'APPROVED' ? 'bg-green-100 text-green-800' :
          row.status === 'REJECTED' ? 'bg-red-100 text-red-800' :
          'bg-gray-100 text-gray-800'
        }`}>
          {row.status}
        </span>
      ),
      maxWidth: '9vw',
    },
    {
      name: 'Submitted Date',
      selector: (row) => row.submittedDate ? moment(row.submittedDate).format('MM-DD-YYYY') : '-',
      maxWidth: '10vw',
    },
    // {
    //   name: 'Approved By',
    //   selector: (row) => row.approvedBy || '-',
    // },
    {
      name: 'Actions',
      selector: (row) => (
        <div className="flex space-x-4">
          {row.status === 'PENDING' && (
            <>
                <button
                  onClick={() => handleApprove(row.id)}
                  className="text-black hover:text-black"
                >
                  <FcApproval size={24} data-tip data-for="approveTip" />
                  <CustomToolTip id="approveTip" title="Approve" />
                </button>
              <button
                onClick={() => handleReject(row.id)}
                className="text-black hover:text-black"
              >
                <MdCancel size={24} data-tip data-for="rejectTip" />
                <CustomToolTip id="rejectTip" title="Reject" />
              </button>
            </>
          )}
          <button
            onClick={() => handleEdit(row.id)}
            className="text-primary hover:text-primaryDark"
          >
            <>
              <MdEdit size={24} data-tip data-for="editTip" />
              <CustomToolTip id="editTip" title="Edit" />
            </>
          </button>

          <button
            onClick={() => handleView(row.id)}
            className="text-primary hover:text-primaryDark"
          >
            <MdVisibility size={24} data-tip data-for="viewTip" />
            <CustomToolTip id="viewTip" title="View" />
          </button>
        </div>
      ),
      maxWidth: '12vw',
    },
  ];

  const handlePageChange = (page) => {
    dispatch(requestTimeOffRequestsAction({ 
      page: page, 
      size: timeOffRequestsState?.size || 10,
      employeeName: search,
      sort: 'desc',
      status: 'PENDING'
    }));
  };

  const handleRowsChange = (size) => {
    dispatch(requestTimeOffRequestsAction({ 
      page: timeOffRequestsState?.page || 0, 
      size: size,
      employeeName: search,
      sort: 'desc',
      status: 'PENDING'
    }));
  };

  const handleApprove = (id) => {
    setSelectedId(id);
    setModalType('approve');
    setShowModal(true);
  };

  const handleReject = (id) => {
    setSelectedId(id);
    setModalType('reject');
    setShowModal(true);
  };

  const handleConfirmAction = () => {
    if (note?.length > 500) {
      toast.error("Note cannot exceed 500 characters");
      return;
    }
    if (modalType === 'approve') {
      dispatch(requestApproveTimeOffRequestAction({ id: selectedId, status: 'APPROVED', approvalRemarks: note }));
      toast.success("Time off request approved successfully");
    } else if (modalType === 'reject') {
      dispatch(requestApproveTimeOffRequestAction({ id: selectedId, status: 'REJECTED', approvalRemarks: note }));
      toast.success("Time off request rejected successfully");
    }
    
    setTimeout(() => {
      dispatch(setResetTimeOffRequestsState());
      dispatch(requestTimeOffRequestsAction({ page: timeOffRequestsState?.page || 0, size: timeOffRequestsState?.size, employeeName: search, sort: 'desc', status: 'PENDING' }));
    }, 500);
    
    setShowModal(false);
    setNote('');
    setSelectedId(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNote('');
    setSelectedId(null);
  };

  const handleEdit = (id) => {
    setSelectedId(id);
    setSelectedTimeOff({ id });
    setIsEditMode(true);
    setIsViewMode(false);
    setShowTimeOffForm(true);
  };

  const handleView = (id) => {
    setSelectedId(id);
    setSelectedTimeOff({ id });
    setIsViewMode(true);
    setIsEditMode(false);
    setShowTimeOffForm(true);
  };

  const handleTimeOffFormClose = () => {
    setShowTimeOffForm(false);
    setSelectedTimeOff(null);
    setIsEditMode(false);
    setIsViewMode(false);
    setSelectedId(null);
  };

  // const handleTimeOffFormSubmit = (timeOffData) => {
  //   // This function is for creating new time off requests
  //   // For edit mode, the form handles submission internally
  //   console.log('New time off request:', timeOffData);
  //   // Add your create logic here if needed
  // };


  useEffect(() => {
    dispatch(requestTimeOffRequestsAction({ page: 0, size: 10, employeeName:search, sort: 'desc', status: 'PENDING' }));
  }, [dispatch, search  ]);


useEffect(() => {
  return () => {
    dispatch(resetCreateTimeOffRequestState());
    dispatch(resetUpdateTimeOffRequestState());
    dispatch(resetApproveTimeOffRequestState());
    dispatch(resetGetTimeOffByIdState());
  }
}, [dispatch]);


  useEffect(() => {
    dispatch(requestUsersListActionWithOutPagination("USER"));
  }, [dispatch]);

  const handleAddTimeOffRequest = () => {
    setShowTimeOffForm(true);
    setIsEditMode(false);
    setIsViewMode(false);
    setSelectedTimeOff(null);
    setSelectedId(null);
  };

  useEffect(() => {
    if (createTimeOffRequestState?.response && !createTimeOffRequestState?.loading && !createTimeOffRequestState?.error) {
      toast.success("Time off request created successfully");
      dispatch(resetCreateTimeOffRequestState());
      dispatch(requestTimeOffRequestsAction({ page: 0, size: 10, employeeName: search, sort: 'desc', status: 'PENDING' }));
      handleTimeOffFormClose();
    }
    if (createTimeOffRequestState?.error && !createTimeOffRequestState?.loading) {
      toast.error(createTimeOffRequestState?.error?.errorData?.data?.errmsg || "Failed to create time off request");
      dispatch(resetCreateTimeOffRequestState());
    }
  }, [createTimeOffRequestState, dispatch, search]);

  // Handle update response separately
  useEffect(() => {
    if (updateTimeOffRequestState?.response && !updateTimeOffRequestState?.loading && !updateTimeOffRequestState?.error) {
      toast.success("Time off request updated successfully");
      dispatch(resetUpdateTimeOffRequestState());
      dispatch(requestTimeOffRequestsAction({ page: 0, size: 10, employeeName: search, sort: 'desc', status: 'PENDING' }));
      handleTimeOffFormClose();
    }
    if (updateTimeOffRequestState?.error && !updateTimeOffRequestState?.loading) {
      toast.error(updateTimeOffRequestState?.error?.message?.errmsg || "Failed to update time off request");
      dispatch(resetUpdateTimeOffRequestState());
    }
  }, [updateTimeOffRequestState, dispatch, search]);

  return (
   <div className='p-6 w-full h-[90vh]'>
    {timeOffRequestsState?.loading && <Loader />}

    <div className="absolute flex  mb-4 z-10 right-6">
      
         <button
          onClick={handleAddTimeOffRequest}
          className="flex items-center justify-center bg-primary hover:bg-primaryDark text-white py-1 px-6 mr-4 rounded-full shadow-lg transition-all duration-300"
        >
          <span className="text-2xl font-medium">+</span>
        </button>
      </div>

    <CustomDataTable
        columns={columns}
        search={search}
        setSearch={setSearch}
        data={timeOffRequestsState?.response?.content || []}
        enableSearch={true}
        serverPagenation
        paginationTotalRows={timeOffRequestsState?.response?.totalElements || 0}
        handleChangePage={handlePageChange}
        handleRowsChange={handleRowsChange}
        fixedHeaderScrollHeight={"59vh"}
        noDataComponent={
          <div className="text-center py-8">
            <p className="text-gray-500">No time off requests found</p>
          </div>
        }
        progressPending={timeOffRequestsState?.loading}
      />

    <ModalComponent
      show={showModal}
      classes={"w-1/3 "}
      onClose={handleCloseModal}
      title={modalType === "approve" ? "Approve Time Off Request" : "Reject Time Off Request"}
    >
      <textarea
        type="text"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Enter a note for the employee (optional)"
        className="border p-2 my-2 w-full"
        rows={4}
      />
       <div className="flex justify-between items-center mt-1">
        <div className="text-xs text-gray-500 ml-auto">
          {note?.length || 0}/500 characters
        </div>
      </div>
      <div className="flex justify-end mt-4">
        <button
          onClick={handleCloseModal}
          className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
        >
          Cancel
        </button>
        <button
          onClick={handleConfirmAction}
          className={`${
            modalType === "approve"
              ? "bg-primary hover:bg-primaryDark"
              : "bg-red-600 hover:bg-red-700"
          } text-white px-4 py-2 rounded`}
        >
          {modalType === "approve" ? "Submit" : "Submit"}
        </button>
      </div>
    </ModalComponent>

    {/* Time Off Form Modal */}
    {showTimeOffForm && (
      <TimeOffForm
        show={showTimeOffForm}
        onClose={handleTimeOffFormClose}
        // onSubmit={handleTimeOffFormSubmit}
        timeOff={selectedTimeOff}
        title={isViewMode ? "View Time Off Request" : isEditMode ? "Edit Time Off Request" : "Request Time Off"}
        isEditMode={isEditMode}
        isViewMode={isViewMode}
        timeOffId={selectedId}
        usersList={usersList?.response || []}
      />
    )}
      
   </div>
  )
}

export default Hoc(TimeOff);